import ClassicReenrollmentTriggerSetsRenderer from 'flow-doctor-lib/components/filters/classicReenrollment/ClassicReenrollmentTriggerSetsRenderer';
import FixedWidthEnrollmentFilterWrapper from 'flow-doctor-lib/components/diagnosis/FixedWidthEnrollmentFilterWrapper';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBox from 'UIComponents/layout/UIBox';
import Small from 'UIComponents/elements/Small';
import { InfoIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
import ClassicReenrollmentTriggerSetsEvalExplanation from 'flow-doctor-lib/components/diagnosis/non-enrollment/validation/triggerChecks/ClassicReenrollmentTriggerSetsEvalExplanation';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ClassicReenrollmentTriggerSetsEvalRenderer = ({
  portalId,
  objectTypeId,
  triggerMatchResults
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "400",
    as: "div",
    children: triggerMatchResults.map((result, i) => /*#__PURE__*/_jsxs(UIFlex, {
      gap: 20,
      className: "m-y-4",
      children: [/*#__PURE__*/_jsx(UIBox, {
        shrink: 0,
        children: /*#__PURE__*/_jsxs(FixedWidthEnrollmentFilterWrapper, {
          children: [/*#__PURE__*/_jsx(ClassicReenrollmentTriggerSetsRenderer, {
            portalId: portalId,
            objectTypeId: objectTypeId,
            condensed: true,
            reEnrollmentTriggerSets: [result.triggerSet]
          }), result.matchResult === 'INVALID_PROPERTY_VALUE' && /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsxs(Small, {
              use: "help",
              children: [/*#__PURE__*/_jsx(View, {
                as: "span",
                marginInlineEnd: "100",
                children: /*#__PURE__*/_jsx(InfoIcon, {})
              }), /*#__PURE__*/_jsx(FormattedMessage, {
                message: "flow-doctor-lib.flows.diagnosticWizard.nonEnrollment.diagnosis.validationResults.CLASSIC_REENROLLMENT_TRIGGER.description.failed.contactPropertyCaseSensitive"
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsx(UIBox, {
        children: /*#__PURE__*/_jsx(ClassicReenrollmentTriggerSetsEvalExplanation, {
          matchResult: result.matchResult
        })
      })]
    }, i))
  });
};
export default ClassicReenrollmentTriggerSetsEvalRenderer;